var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.importantlinks = new function () {
    var self = this;
    this.init = function () {
        this.equalizeHeight();
        this.hideImportantLinks();
    }

    this.equalizeHeight = function () {
        var winWidth = window.innerWidth;
        // Select and loop the container element of the elements you want to equalise
        if (winWidth > 992) {
            $('.important-links').each(function () {

                // Cache the highest
                var highestBox = 0;

                // Select and loop the elements you want to equalise
                $('.important-links-content', this).each(function () {

                    // If this box is higher than the cached highest then store it
                    if ($(this).height() > highestBox) {
                        highestBox = $(this).height();
                    }

                });

                // Set the height of all those children to whichever was highest 
                $('.important-links-content', this).css("min-height",highestBox);
                
            });

           
        } else {
            $('.important-links-content').css("min-height", "0");
            $(".link-box-widget").appendTo(".link-box-widgets-mobile");
        }

        
    }

    this.hideImportantLinks = function() {
        var winWidth = window.innerWidth;
        if (winWidth < 992 && !$("#content").children(".frontpage-hero").length != 0) {
            $(".important-links").hide();
            
        } else {
            $(".important-links").show();
            
        }
    }
} ();






